import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export interface EmployeeOrgChartProps {
  className?: string;
}

export const EmployeeOrgChart = ({ className }: EmployeeOrgChartProps) => {
  const { t } = useTranslation(['common']);
  return (
    <div
      className={classNames(
        "text-neutral-900 font-['Poppins'] bg-white rounded-2xl shadow overflow-hidden",
        className
      )}
    >
      <div>{t('Org Chart goes here')}</div>
    </div>
  );
};

export default EmployeeOrgChart;
